import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_suchergebnis } from "../Controls/dbh_suchergebnis";
import { dbh_custom_validation } from "../ClientValidation/dbh_custom_validation";

if (dbh_helper.getUrlArea() == "stammdaten") {
    $(document).ready(function () {
        let id = dbh_helper.getUrlParameter("id");
        if (id && id != "") {
            $("#addMitgliedBtn").on("click", function () {
                dbh_helper.SendGetRequest("AddMitgliedPopupView", "Stammdaten", [["id", id]], "#addMitglied-placeholder", function () {
                    $("#AddMitgliedViewComponentPopup").fadeIn("fast");

                    const grpID = $("#FK_AdressGruppen").val().toString();
                    GetMitgliederOptions(grpID);

                    $("#FK_AdressGruppen").on("change", function () {
                        const curId = $(this).val().toString();
                        GetMitgliederOptions(curId);
                    })
                });
            })

            // BetreuerInnen
            $(document).on('click', '#addNewMitarbeiter ', function () {
                dbh_helper.SendGetRequest("AddMitarbeiterWohnungPopup", "Stammdaten", [['id', id]], '#tablePopup-placeholder', () => {
                    $("#NewEditViewComponentPopup").show();
                });
            });

            $(document).on('click', '.dbhTableMitarbeiterEditBtn ', function (e) {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("EditMitarbeiterWohnungPopup", "Stammdaten", [['id', zuweisungId]], '#tablePopup-placeholder', () => {
                    $("#NewEditViewComponentPopup").show();
                });
                e.stopPropagation();
            });
            $(document).on('click', '#WGBetreuerTabelleMitSuche .tableDeleteButton', function () {
                const mitId = $(this).closest("tr").data("rowid");
                dbh_helper.SendGetRequest("DeleteMitarbeiterWohnungConfirm", "Stammdaten", [['id', mitId]], '#tablePopup-placeholder', () => {
                    $("#DeleteWngMitarbeiterViewComponentPopup").show();
                });
            });

            /*after Delete-Confirm*/
            $(document).on('click', '#btnDeleteMitgliedWngZuweisung', function () {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("DeleteMitarbeiterWohnung", "Stammdaten", [['id', zuweisungId]], null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGBetreuerTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#DeleteWngMitarbeiterViewComponentPopup").hide();
                });
            });

            /*after Edit-Confirm*/
            $(document).on('click', '#btnEditMitgliedWngZuweisung', function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);
                const parameter = dbh_helper.getParameterArrayForForm(form);

                let dbhCustomValidation = new dbh_custom_validation();
                if (!dbhCustomValidation.validateForm("#NewEditViewComponentPopup")) {
                    return;
                }

                FormatDatesVonBisInParameterArray(parameter);

                dbh_helper.SendGetRequest("EditMitarbeiterWohnung", "Stammdaten", parameter, null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGBetreuerTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#NewEditViewComponentPopup").hide();
                }, () => {

                });
            });

            /*after New-Confirm*/
            $(document).on('click', '#btnAddMitgliedWngZuweisung', function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);
                const parameter = dbh_helper.getParameterArrayForForm(form);

                let dbhCustomValidation = new dbh_custom_validation();
                if (!dbhCustomValidation.validateForm("#NewEditViewComponentPopup")) {
                    return;
                }

                FormatDatesVonBisInParameterArray(parameter);

                dbh_helper.SendGetRequest("AddMitarbeiterWohnung", "Stammdaten", parameter, null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGBetreuerTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#NewEditViewComponentPopup").hide();
                });
            });

            /*Cancel-Btns*/
            $(document).on('click', '#btnCancelAddMitgliedWng', function () {
                $("#NewEditViewComponentPopup").hide();
            });

            $(document).on('click', '#btnCancelMitgliedWngZuweisung', function () {
                $("#DeleteWngMitarbeiterViewComponentPopup").hide();
            });

            // Dienstarten
            $(document).on('click', '#addNewDienstart ', function () {
                dbh_helper.SendGetRequest("AddDienstartWohnungPopup", "Stammdaten", [['id', id]], '#tablePopup-placeholder', () => {
                    $("#AddEditDienstartViewComponentPopup").show();
                });
            });

            $(document).on('click', '#btnAddDienstartZuweisung', function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);
                const parameter = dbh_helper.getParameterArrayForForm(form);

                let dbhCustomValidation = new dbh_custom_validation();
                if (!dbhCustomValidation.validateForm("#AddEditDienstartViewComponentPopup")) {
                    return;
                }

                FormatDatesVonBisInParameterArray(parameter);

                dbh_helper.SendGetRequest("AddDienstartWohnung", "Stammdaten", parameter, null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGDienstartenTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#AddEditDienstartViewComponentPopup").hide();
                });
            });

            $(document).on('click', '.dbhTableDienstartEditBtn ', function (e) {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("EditDienstartWohnungPopup", "Stammdaten", [['id', zuweisungId]], '#tablePopup-placeholder', () => {
                    $("#AddEditDienstartViewComponentPopup").show();
                });
                e.stopPropagation();
            });

            $(document).on('click', '#btnEditDienstartZuweisung', function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);
                const parameter = dbh_helper.getParameterArrayForForm(form);

                let dbhCustomValidation = new dbh_custom_validation();
                if (!dbhCustomValidation.validateForm("#AddEditDienstartViewComponentPopup")) {
                    return;
                }

                FormatDatesVonBisInParameterArray(parameter);

                dbh_helper.SendGetRequest("EditDienstartWohnung", "Stammdaten", parameter, null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGDienstartenTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#AddEditDienstartViewComponentPopup").hide();
                }, () => {

                });
            });

            $(document).on('click', '#WGDienstartenTabelleMitSuche .tableDeleteButton', function () {
                const mitId = $(this).closest("tr").data("rowid");
                dbh_helper.SendGetRequest("DeleteDienstartWohnungConfirm", "Stammdaten", [['id', mitId]], '#tablePopup-placeholder', () => {
                    $("#DeleteDienstartViewComponentPopup").show();
                });
            });

            $(document).on('click', '#btnDeleteDienstartZuweisung', function () {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("DeleteDienstartWohnung", "Stammdaten", [['id', zuweisungId]], null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGDienstartenTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#DeleteDienstartViewComponentPopup").hide();
                });
            });
            
            $(document).on('click', '#btnCancelAddDienstart', function () {
                $("#AddEditDienstartViewComponentPopup").hide();
            });

            $(document).on('click', '#btnCancelDeleteDienstartZuweisung', function () {
                $("#DeleteDienstartViewComponentPopup").hide();
            });

            /* Fahrzeuge pro Wohnung */
            $(document).on('click', '#addNewFahrzeug ', function () {
                dbh_helper.SendGetRequest("AddFahrzeugWohnungPopup", "Stammdaten", [['id', id]], '#tablePopup-placeholder', () => {
                    $("#AddEditFahrzeugViewComponentPopup").show();
                });
            });
            $(document).on('click', '#btnAddFahrzeugZuweisung', function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);
                const parameter = dbh_helper.getParameterArrayForForm(form);

                let dbhCustomValidation = new dbh_custom_validation();
                if (!dbhCustomValidation.validateForm("#AddEditFahrzeugViewComponentPopup")) {
                    return;
                }

                FormatDatesVonBisInParameterArray(parameter);

                dbh_helper.SendPostRequest("AddFahrzeugWohnung", "Stammdaten", parameter, null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGFahrzeugeTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#AddEditFahrzeugViewComponentPopup").hide();
                });
            });

            $(document).on('click', '.dbhTableFahrzeugEditBtn ', function (e) {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("EditFahrzeugWohnungPopup", "Stammdaten", [['id', zuweisungId]], '#tablePopup-placeholder', () => {
                    $("#AddEditFahrzeugViewComponentPopup").show();
                });
                e.stopPropagation();
            });

            $(document).on('click', '#btnEditFahrzeugZuweisung', function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);
                const parameter = dbh_helper.getParameterArrayForForm(form);

                let dbhCustomValidation = new dbh_custom_validation();
                if (!dbhCustomValidation.validateForm("#AddEditFahrzeugViewComponentPopup")) {
                    return;
                }

                FormatDatesVonBisInParameterArray(parameter);

                dbh_helper.SendPostRequest("EditFahrzeugWohnung", "Stammdaten", parameter, null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGFahrzeugeTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#AddEditFahrzeugViewComponentPopup").hide();
                }, () => {

                });
            });

            $(document).on('click', '#WGFahrzeugeTabelleMitSuche .tableDeleteButton', function () {
                const mitId = $(this).closest("tr").data("rowid");
                dbh_helper.SendGetRequest("DeleteFahrzeugWohnungConfirm", "Stammdaten", [['id', mitId]], '#tablePopup-placeholder', () => {
                    $("#DeleteFahrzeugViewComponentPopup").show();
                });
            });

            $(document).on('click', '#btnDeleteFahrzeugZuweisung', function () {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("DeleteFahrzeugWohnung", "Stammdaten", [['id', zuweisungId]], null, () => {
                    new dbh_suchergebnis().defaultReloadSearchResult($('#WGFahrzeugeTabelleMitSuche .dbhSuchergebnis').first().get(0));
                    $("#DeleteFahrzeugViewComponentPopup").hide();
                });
            });

            $(document).on('click', '#btnCancelAddFahrzeug', function () {
                $("#AddEditFahrzeugViewComponentPopup").hide();
            });
            $(document).on('click', '#btnCancelDeleteFahrzeugZuweisung', function () {
                $("#DeleteFahrzeugViewComponentPopup").hide();
            });

            /* Pflegesätze stationär */

            $(document).off('click', '#addNewPflegesatz');
            $(document).on('click', '#addNewPflegesatz', function () {
                dbh_helper.SendGetRequest("AddPflegesaetzePopup", "Stammdaten", [['id', id]], '#tablePopup-placeholder', () => {
                    $("#AddEditPflegesaetzeViewComponentPopup").show();

                    /*after New-Confirm*/
                    $(document).off('click', '#btnAddPflegesaetze');
                    $(document).on('click', '#btnAddPflegesaetze', function (e) {
                        const form = dbh_helper.findNearestForm(e.currentTarget);
                        const parameter = dbh_helper.getParameterArrayForForm(form);

                        let dbhCustomValidation = new dbh_custom_validation();
                        if (!dbhCustomValidation.validateForm("#AddEditPflegesaetzeViewComponentPopup")) {
                            return;
                        }

                        FormatDatesVonBisInParameterArray(parameter);

                        dbh_helper.SendGetRequest("AddPflegesaetze", "Stammdaten", parameter, null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#PflegesaetzeTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#AddEditPflegesaetzeViewComponentPopup").hide();
                        });
                    });
                });
            });

            $(document).off('click', '.dbhTablePflegesaetzeEditBtn');
            $(document).on('click', '.dbhTablePflegesaetzeEditBtn', function (e) {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("EditPflegesaetzePopup", "Stammdaten", [['id', zuweisungId]], '#tablePopup-placeholder', () => {
                    $("#AddEditPflegesaetzeViewComponentPopup").show();

                    /*after Edit-Confirm*/
                    $(document).off('click', '#btnAddPflegesaetze');
                    $(document).on('click', '#btnAddPflegesaetze', function (e) {
                        const form = dbh_helper.findNearestForm(e.currentTarget);
                        const parameter = dbh_helper.getParameterArrayForForm(form);

                        let dbhCustomValidation = new dbh_custom_validation();
                        if (!dbhCustomValidation.validateForm("#AddEditPflegesaetzeViewComponentPopup")) {
                            return;
                        }

                        FormatDatesVonBisInParameterArray(parameter);

                        dbh_helper.SendGetRequest("EditPflegesaetze", "Stammdaten", parameter, null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#PflegesaetzeTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#AddEditPflegesaetzeViewComponentPopup").hide();
                        }, () => {

                        });
                    });
                });
                e.stopPropagation();
            });

            $(document).off('click', '#PflegesaetzeTabelleMitSuche .tableDeleteButton');
            $(document).on('click', '#PflegesaetzeTabelleMitSuche .tableDeleteButton', function () {
                const mitId = $(this).closest("tr").data("rowid");
                dbh_helper.SendGetRequest("DeletePflegesaetzeConfirm", "Stammdaten", [['id', mitId]], '#tablePopup-placeholder', () => {
                    $("#DeletePflegesaetzeViewComponentPopup").show();

                    /*after Delete-Confirm*/
                    $(document).off('click', '#btnDeletePflegesaetze');
                    $(document).on('click', '#btnDeletePflegesaetze', function () {
                        const zuweisungId = $(this).data("id");
                        dbh_helper.SendGetRequest("DeletePflegesaetze", "Stammdaten", [['id', zuweisungId]], null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#PflegesaetzeTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#DeletePflegesaetzeViewComponentPopup").hide();
                        });
                    });
                });
            });

            /* Pflegesätze ambulant */

            $(document).off('click', '#addNewPflegesatzFls');
            $(document).on('click', '#addNewPflegesatzFls', function () {
                dbh_helper.SendGetRequest("AddPflegesaetzeFlsPopup", "Stammdaten", [['id', id]], '#tablePopup-placeholder', () => {
                    $("#AddEditPflegesaetzeFlsViewComponentPopup").show();

                    /*after New-Confirm*/
                    $(document).off('click', '#btnAddPflegesaetzeFls');
                    $(document).on('click', '#btnAddPflegesaetzeFls', function (e) {
                        const form = dbh_helper.findNearestForm(e.currentTarget);
                        const parameter = dbh_helper.getParameterArrayForForm(form);

                        let dbhCustomValidation = new dbh_custom_validation();
                        if (!dbhCustomValidation.validateForm("#AddEditPflegesaetzeFlsViewComponentPopup")) {
                            return;
                        }

                        FormatDatesVonBisInParameterArray(parameter);

                        dbh_helper.SendGetRequest("AddPflegesaetzeFls", "Stammdaten", parameter, null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#PflegesaetzeFlsTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#AddEditPflegesaetzeFlsViewComponentPopup").hide();
                        });
                    });
                });
            });

            $(document).off('click', '.dbhTablePflegesaetzeFlsEditBtn');
            $(document).on('click', '.dbhTablePflegesaetzeFlsEditBtn', function (e) {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("EditPflegesaetzeFlsPopup", "Stammdaten", [['id', zuweisungId]], '#tablePopup-placeholder', () => {
                    $("#AddEditPflegesaetzeFlsViewComponentPopup").show();

                    /*after Edit-Confirm*/
                    $(document).off('click', '#btnAddPflegesaetzeFls');
                    $(document).on('click', '#btnAddPflegesaetzeFls', function (e) {
                        const form = dbh_helper.findNearestForm(e.currentTarget);
                        const parameter = dbh_helper.getParameterArrayForForm(form);

                        let dbhCustomValidation = new dbh_custom_validation();
                        if (!dbhCustomValidation.validateForm("#AddEditPflegesaetzeFlsViewComponentPopup")) {
                            return;
                        }

                        FormatDatesVonBisInParameterArray(parameter);

                        dbh_helper.SendGetRequest("EditPflegesaetzeFls", "Stammdaten", parameter, null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#PflegesaetzeFlsTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#AddEditPflegesaetzeFlsViewComponentPopup").hide();
                        }, () => {

                        });
                    });
                });
                e.stopPropagation();
            });

            $(document).off('click', '#PflegesaetzeFlsTabelleMitSuche .tableDeleteButton');
            $(document).on('click', '#PflegesaetzeFlsTabelleMitSuche .tableDeleteButton', function () {
                const mitId = $(this).closest("tr").data("rowid");
                dbh_helper.SendGetRequest("DeletePflegesaetzeFlsConfirm", "Stammdaten", [['id', mitId]], '#tablePopup-placeholder', () => {
                    $("#DeletePflegesaetzeFlsViewComponentPopup").show();

                    /*after Delete-Confirm*/
                    $(document).off('click', '#btnDeletePflegesaetzeFls');
                    $(document).on('click', '#btnDeletePflegesaetzeFls', function () {
                        const zuweisungId = $(this).data("id");
                        dbh_helper.SendGetRequest("DeletePflegesaetzeFls", "Stammdaten", [['id', zuweisungId]], null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#PflegesaetzeFlsTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#DeletePflegesaetzeFlsViewComponentPopup").hide();
                        });
                    });
                });
            });

            /* Koordinatorenpunkte */

            $(document).off('click', '#addNewKoordinatorenpunkte');
            $(document).on('click', '#addNewKoordinatorenpunkte', function () {
                dbh_helper.SendGetRequest("AddKoordinatorenpunktePopup", "Stammdaten", [['id', id]], '#tablePopup-placeholder', () => {
                    $("#AddEditKoordinatorenpunkteViewComponentPopup").show();

                    /*after New-Confirm*/
                    $(document).off('click', '#btnAddKoordinatorenpunkte');
                    $(document).on('click', '#btnAddKoordinatorenpunkte', function (e) {
                        const form = dbh_helper.findNearestForm(e.currentTarget);
                        const parameter = dbh_helper.getParameterArrayForForm(form);

                        let dbhCustomValidation = new dbh_custom_validation();
                        if (!dbhCustomValidation.validateForm("#AddEditKoordinatorenpunkteViewComponentPopup")) {
                            return;
                        }

                        FormatDatesVonBisInParameterArray(parameter);

                        dbh_helper.SendGetRequest("AddKoordinatorenpunkte", "Stammdaten", parameter, null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#KoordinatorenpunkteTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#AddEditKoordinatorenpunkteViewComponentPopup").hide();
                        });
                    });
                });
            });

            $(document).off('click', '.dbhTableKoordinatorenpunkteEditBtn');
            $(document).on('click', '.dbhTableKoordinatorenpunkteEditBtn', function (e) {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("EditKoordinatorenpunktePopup", "Stammdaten", [['id', zuweisungId]], '#tablePopup-placeholder', () => {
                    $("#AddEditKoordinatorenpunkteViewComponentPopup").show();

                    /*after Edit-Confirm*/
                    $(document).off('click', '#btnAddKoordinatorenpunkte');
                    $(document).on('click', '#btnAddKoordinatorenpunkte', function (e) {
                        const form = dbh_helper.findNearestForm(e.currentTarget);
                        const parameter = dbh_helper.getParameterArrayForForm(form);

                        let dbhCustomValidation = new dbh_custom_validation();
                        if (!dbhCustomValidation.validateForm("#AddEditKoordinatorenpunkteViewComponentPopup")) {
                            return;
                        }

                        FormatDatesVonBisInParameterArray(parameter);

                        dbh_helper.SendGetRequest("EditKoordinatorenpunkte", "Stammdaten", parameter, null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#KoordinatorenpunkteTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#AddEditKoordinatorenpunkteViewComponentPopup").hide();
                        }, () => {

                        });
                    });
                });
                e.stopPropagation();
            });

            $(document).off('click', '#KoordinatorenpunkteTabelleMitSuche .tableDeleteButton');
            $(document).on('click', '#KoordinatorenpunkteTabelleMitSuche .tableDeleteButton', function () {
                const mitId = $(this).closest("tr").data("rowid");
                dbh_helper.SendGetRequest("DeleteKoordinatorenpunkteConfirm", "Stammdaten", [['id', mitId]], '#tablePopup-placeholder', () => {
                    $("#DeleteKoordinatorenpunkteViewComponentPopup").show();

                    /*after Delete-Confirm*/
                    $(document).off('click', '#btnDeleteKoordinatorenpunkte');
                    $(document).on('click', '#btnDeleteKoordinatorenpunkte', function () {
                        const zuweisungId = $(this).data("id");
                        dbh_helper.SendGetRequest("DeleteKoordinatorenpunkte", "Stammdaten", [['id', zuweisungId]], null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#KoordinatorenpunkteTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#DeleteKoordinatorenpunkteViewComponentPopup").hide();
                        });
                    });
                });
            });

            /* Jugendämter in TG & BG Kategorie */

            $(document).off('click', '#addNewTaschenBekleidungsgeldJugendaemter');
            $(document).on('click', '#addNewTaschenBekleidungsgeldJugendaemter', function () {
                dbh_helper.SendGetRequest("AddTaschenBekleidungsgeldJugendaemterPopup", "Stammdaten", [['id', id]], '#popup-placeholder', () => {
                    $("#AddEditTaschenBekleidungsgeldJugendaemterViewComponentPopup").show();

                    /*after New-Confirm*/
                    $(document).off('click', '#addEditJugendaemterBtn');
                    $(document).on('click', '#addEditJugendaemterBtn', function (e) {
                        const form = dbh_helper.findNearestForm(e.currentTarget);
                        const parameter = dbh_helper.getParameterArrayForForm(form);

                        let dbhCustomValidation = new dbh_custom_validation();
                        if (!dbhCustomValidation.validateForm("#AddEditTaschenBekleidungsgeldJugendaemterViewComponentPopup")) {
                            return;
                        }

                        FormatDatesVonBisInParameterArray(parameter);

                        dbh_helper.SendGetRequest("AddTaschenBekleidungsgeldJugendaemter", "Stammdaten", parameter, null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#TaschenBekleidungsgeldJugendaemterTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#AddEditTaschenBekleidungsgeldJugendaemterViewComponentPopup").hide();
                        });
                    });
                });
            });

            $(document).off('click', '.dbhTableTaschenBekleidungsgeldJugendaemterEditBtn');
            $(document).on('click', '.dbhTableTaschenBekleidungsgeldJugendaemterEditBtn', function (e) {
                const zuweisungId = $(this).data("id");
                dbh_helper.SendGetRequest("EditTaschenBekleidungsgeldJugendaemterPopup", "Stammdaten", [['id', zuweisungId]], '#popup-placeholder', () => {
                    $("#AddEditTaschenBekleidungsgeldJugendaemterViewComponentPopup").show();

                    /*after Edit-Confirm*/
                    $(document).off('click', '#addEditJugendaemterBtn');
                    $(document).on('click', '#addEditJugendaemterBtn', function (e) {
                        const form = dbh_helper.findNearestForm(e.currentTarget);
                        const parameter = dbh_helper.getParameterArrayForForm(form);

                        let dbhCustomValidation = new dbh_custom_validation();
                        if (!dbhCustomValidation.validateForm("#AddEditTaschenBekleidungsgeldJugendaemterViewComponentPopup")) {
                            return;
                        }

                        FormatDatesVonBisInParameterArray(parameter);

                        dbh_helper.SendGetRequest("EditTaschenBekleidungsgeldJugendaemter", "Stammdaten", parameter, null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#TaschenBekleidungsgeldJugendaemterTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#AddEditTaschenBekleidungsgeldJugendaemterViewComponentPopup").hide();
                        }, () => {

                        });
                    });
                });
                e.stopPropagation();
            });

            $(document).off('click', '#TaschenBekleidungsgeldJugendaemterTabelleMitSuche .tableDeleteButton');
            $(document).on('click', '#TaschenBekleidungsgeldJugendaemterTabelleMitSuche .tableDeleteButton', function () {
                const mitId = $(this).closest("tr").data("rowid");
                dbh_helper.SendGetRequest("DeleteTaschenBekleidungsgeldJugendaemterPopupView", "Stammdaten", [['id', mitId]], '#popup-placeholder', () => {
                    $("#DeleteTaschenBekleidungsgeldJugendaemterViewComponentPopup").show();

                    /*after Delete-Confirm*/
                    $(document).off('click', '#deleteTaschenBekleidungsgeldJugendaemterBtn');
                    $(document).on('click', '#deleteTaschenBekleidungsgeldJugendaemterBtn', function () {
                        const zuweisungId = $(this).data("id");
                        dbh_helper.SendGetRequest("DeleteTaschenBekleidungsgeldJugendaemter", "Stammdaten", [['id', zuweisungId]], null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#TaschenBekleidungsgeldJugendaemterTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#DeleteTaschenBekleidungsgeldJugendaemterViewComponentPopup").hide();
                        });
                    });
                });
            });

            $(document).off('click', '#TgBgTabelleMitSuche .tableDeleteButton');
            $(document).on('click', '#TgBgTabelleMitSuche .tableDeleteButton', function () {
                const mitId = $(this).closest("tr").data("rowid");
                dbh_helper.SendGetRequest("DeleteTaschenBekleidungsgeldPopupView", "Stammdaten", [['id', mitId]], '#popup-placeholder', () => {
                    $("#DeleteTaschenBekleidungsgeldViewComponentPopup").show();

                    /*after Delete-Confirm*/
                    $(document).off('click', '#deleteTaschenBekleidungsgeldBtn');
                    $(document).on('click', '#deleteTaschenBekleidungsgeldBtn', function () {
                        const zuweisungId = $(this).data("id");
                        dbh_helper.SendGetRequest("DeleteTaschenBekleidungsgeld", "Stammdaten", [['id', zuweisungId]], null, () => {
                            new dbh_suchergebnis().defaultReloadSearchResult($('#TgBgTabelleMitSuche .dbhSuchergebnis').first().get(0));
                            $("#DeleteTaschenBekleidungsgeldViewComponentPopup").hide();
                        });
                    });
                });
            });

        }
        else {
            if ($('#btnToggleEditAndViewMode').length > 0) {
                window.setTimeout(() => {
                    $('#btnToggleEditAndViewMode').get(0).click();
                }, 200);
            }
        }

        $("#dbh_PflegesatzgruppenDetails #btnLoeschen").on("click", function () {
            dbh_helper.SendGetRequest('PflegesatzgruppeLoeschen', 'Stammdaten', [["id", id]], '#popup-placeholder', () => { $("#DeleteConfirmViewComponentPopup").fadeIn("fast"); });
        });

        $("#dbh_VorlagenDetails #btnLoeschen").on("click", function () {
            dbh_helper.SendGetRequest('DeleteVorlagePopupView', 'Stammdaten/Eingangsrechnungen', [["id", id]], '#popup-placeholder', () => { $("#DeleteVorlageViewComponentPopup").fadeIn("fast"); });
        });

        $(document).on('click', '.AdressenTeamSuchenModel .tableDeleteButton', function () {
            const rowId = $(this).closest('tr').data("rowid");
            dbh_helper.SendGetRequest('DeleteMitgliedPopupView', 'Stammdaten', [["id", rowId]], '#addMitglied-placeholder', () => { $("#DeleteMitgliedViewComponentPopup").show() });
        });

        $(document).on('click', '#HilfenTabelleMitSuche .tableDeleteButton', function () {
            const rowId = $(this).closest('tr').data("rowid");
            dbh_helper.SendGetRequest('DeleteHilfePopupView', 'Stammdaten', [["id", rowId]], '#popup-placeholder', () => { $("#DeleteHilfeViewComponentPopup").fadeIn("fast"); });
        });
        $(document).on('click', '#deleteHilfeBtn', function (e) {
            const form = dbh_helper.findNearestForm(e.currentTarget);
            SendPostWithReloadTable(form, "DeleteHilfe", "Stammdaten", '#HilfenTabelleMitSuche .dbhSuchergebnis', "#DeleteHilfeViewComponentPopup");
        });

        $('#TgBgKategorienTabelleMitSuche tr[data-rowid="fa069cc0-0905-44b0-9dbe-26dc7672da6b"] .tableDeleteButton').remove();
        $(document).on('click', '#TgBgKategorienTabelleMitSuche .tableDeleteButton', function () {
            const rowId = $(this).closest('tr').data("rowid");
            if (rowId != "fa069cc0-0905-44b0-9dbe-26dc7672da6b") {
                dbh_helper.SendGetRequest('DeleteTaschenBekleidungsgeldKategorienPopupView', 'Stammdaten', [["id", rowId]], '#popup-placeholder', () => { $("#DeleteTaschenBekleidungsgeldKategorienViewComponentPopup").fadeIn("fast"); });
            }
        });
        $(document).on('click', '#deleteTaschenBekleidungsgeldKategorienBtn', function (e) {
            const form = dbh_helper.findNearestForm(e.currentTarget);
            SendPostWithReloadTable(form, "DeleteTaschenBekleidungsgeldKategorien", "Stammdaten", '#TgBgKategorienTabelleMitSuche .dbhSuchergebnis', "#DeleteTaschenBekleidungsgeldKategorienViewComponentPopup");
            window.setTimeout(() => {
                $('#TgBgKategorienTabelleMitSuche tr[data-rowid="fa069cc0-0905-44b0-9dbe-26dc7672da6b"] .tableDeleteButton').remove();
            }, 1000);
        });

        $(document).on('click', '#addTeamMitgliedBtn', function (e) {
            const form = dbh_helper.findNearestForm(e.currentTarget);
            SendPostWithReloadTable(form, "AddMitglied", "Stammdaten", '#MitgliederTabelleMitSuche .dbhSuchergebnis', "#AddMitgliedViewComponentPopup");
        });

        $(document).on('click', '#TeamsTabelleMitSuche .tableDeleteButton', function () {
            const rowId = $(this).closest('tr').data("rowid");
            dbh_helper.SendGetRequest('DeleteTeam', 'Stammdaten', [["id", rowId]], '#popup-placeholder', () => { $("#DeleteTeamViewComponentPopup").fadeIn("fast"); });
        });
        $(document).on('click', '#deleteAdressFromTeamBtn', function (e) {
            const form = dbh_helper.findNearestForm(e.currentTarget);
            SendPostWithReloadTable(form, "DeleteMitglied", "Stammdaten", '#MitgliederTabelleMitSuche .dbhSuchergebnis', "#DeleteMitgliedViewComponentPopup");
        });

        $(document).on('click', '#AdressenVorlagenTabelleMitSuche .tableDeleteButton', function () {
            const rowId = $(this).closest('tr').data("rowid");
            dbh_helper.SendGetRequest('DeleteAdressenVorlagenPopupView', 'Stammdaten/Eingangsrechnungen', [["id", rowId]], '#popup-placeholder', () => { $("#DeleteAdressenVorlagenViewComponentPopup").fadeIn("fast"); });
        });
        $(document).on('click', '#deleteAdressFromVorlageBtn', function (e) {
            const form = dbh_helper.findNearestForm(e.currentTarget);
            const parameter = dbh_helper.getParameterArrayForForm(form);

            dbh_helper.SendPostRequest("DeleteAdressenVorlagen", "Stammdaten/Eingangsrechnungen", parameter, null, () => {
                new dbh_suchergebnis().defaultReloadSearchResult($('#AdressenVorlagenTabelleMitSuche .dbhSuchergebnis').first().get(0));
                $("#DeleteAdressenVorlagenViewComponentPopup").hide();
            });
        });

        $(document).off('click', '#addNewAdressenVorlagen');
        $("#addNewAdressenVorlagen").on("click", function () {
            dbh_helper.SendGetRequest("AddAdressenVorlagenPopupView", "Stammdaten/Eingangsrechnungen", [['id', id]], '#popup-placeholder', () => {
                $("#AddAdressenVorlagenViewComponentPopup").show();

                /*after New-Confirm*/
                $(document).off('click', '#addAdresseVorlagenMitgliedBtn');
                $(document).on('click', '#addAdresseVorlagenMitgliedBtn', function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);
                    const parameter = dbh_helper.getParameterArrayForForm(form);

                    let dbhCustomValidation = new dbh_custom_validation();
                    if (!dbhCustomValidation.validateForm("#AddAdressenVorlagenViewComponentPopup")) {
                        return;
                    }

                    dbh_helper.SendPostRequest("AddAdressenVorlagen", "Stammdaten/Eingangsrechnungen", parameter, null, () => {
                        new dbh_suchergebnis().defaultReloadSearchResult($('#AdressenVorlagenTabelleMitSuche .dbhSuchergebnis').first().get(0));
                        $("#AddAdressenVorlagenViewComponentPopup").hide();
                    });
                });
            });
        })

        $("#typescriptMitgliedProxy").on("click", function (e, actionName, controllerName, parameter, htmlId, doOnSuccess) {
            dbh_helper.SendGetRequest(actionName, controllerName, parameter, htmlId, doOnSuccess);
        });

        $("#typescriptProxy").on("click", function (e, actionName, controllerName, parameter, htmlId, doOnSuccess) {
            dbh_helper.SendGetRequest(actionName, controllerName, parameter, htmlId, doOnSuccess);
        });
    });

    $('#dbh_StammdatenHilfenDetails').ready(function () {
        let id = dbh_helper.getUrlParameter("id");
        if ((!id || id == undefined || id == "") && window.location.pathname.toLowerCase().indexOf("stammdaten/hilfendetails") > 0) {
            $('#btnToggleEditAndViewMode').ready(function () {
                $('#btnToggleEditAndViewMode').get(0).click();
                $('#btnToggleEditAndViewMode').hide();
            });
        }
    });
    $('#dbh_StammdatenTeamDetails').ready(function () {
        let id = dbh_helper.getUrlParameter("id");
        if ((!id || id == undefined || id == "") && window.location.pathname.toLowerCase().indexOf("stammdaten/teamdetails") > 0) {
            $('#btnToggleEditAndViewMode').ready(function () {
                $('#btnToggleEditAndViewMode').get(0).click();
                $('#btnToggleEditAndViewMode').hide();
            });
        }
    });
    $('#TaschenBekleidungsgeldDetails').ready(function () {
        let id = dbh_helper.getUrlParameter("id");
        if ((!id || id == undefined || id == "") && window.location.pathname.toLowerCase().indexOf("stammdaten/taschenbekleidungsgelddetails") > 0) {
            $('#btnToggleEditAndViewMode').ready(function () {
                $('#btnToggleEditAndViewMode').get(0).click();
                $('#btnToggleEditAndViewMode').hide();
            });
        }
    });
    $('#TaschenBekleidungsgeldKategorienDetails').ready(function () {
        let id = dbh_helper.getUrlParameter("id");
        if ((!id || id == undefined || id == "") && window.location.pathname.toLowerCase().indexOf("stammdaten/taschenbekleidungsgeldkategoriendetails") > 0) {
            $('#btnToggleEditAndViewMode').ready(function () {
                $('#btnToggleEditAndViewMode').get(0).click();
                $('#btnToggleEditAndViewMode').hide();
            });
        }
    });
}

const GetMitgliederOptions = (id) => {
    new dbh_ajax().sendGetRequest({
        actionName: "LoadAdressenForMitglied",
        controllerName: "Stammdaten",
        parameter: [["pk_adressgruppe", id]],
        callbackSuccess: (ajaxResult: any) => {
            const json = ajaxResult.responseJSON;
            const select = document.createElement("select");
            select.classList.add("form-text");
            select.id = "FK_Mitglied";
            select.name = "FK_Mitglied";

            for (let i = 0; i < json.length; i++) {
                const option = document.createElement("option");
                option.value = json[i].value;
                option.text = json[i].text;
                select.add(option);
            }

            $(`#partnerDropdownContainer`).html(select);
        },
        callbackError: (ajaxResult: object) => {
            const select = document.createElement("select");
            select.classList.add("form-text");
            select.id = "FK_Mitglied";
            select.name = "FK_Mitglied";
            $(`#partnerDropdownContainer`).html(select);
        }
    });
}

const FormatDatesVonBisInParameterArray = (parameter) => {
    for (let i = 0; i < parameter.length; i++) {
        if (parameter[i][0] === "Von" || parameter[i][0] === "Bis") {
            const dateSplit = parameter[i][1].split('.');
            parameter[i][1] = `${dateSplit[1]}-${dateSplit[0]}-${dateSplit[2]}`;
        }
    }
}

const SendPostWithReloadTable = (form, action, controller, tableSelectorToReload, popupIdToHide) => {

    new dbh_ajax().sendPostRequest({
        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
        actionName: action,
        controllerName: controller,
        parameter: dbh_helper.getParameterStringForForm(form),
        callbackSuccess: (ajaxResult: any) => {
            new dbh_suchergebnis().defaultReloadSearchResult($(tableSelectorToReload).first().get(0));
            $(popupIdToHide).hide();
        }
    });
}